import React from 'react';

const MyHotelSitBooking = () => {
    return (
        <div>
            my hotel sit booking page
        </div>
    );
};

export default MyHotelSitBooking;